import { isValidEmail } from './email';
import { formatUsPhone, isValidUsPhone } from './phone';

export type ContactMethod = 'email' | 'sms';

export type ContactNormalizeResult =
  | { ok: true; value: string }
  | { ok: false; errorKey: 'auth.errors.invalidEmail' | 'auth.errors.invalidPhone' };

export function normalizeContact(method: ContactMethod, raw: string): ContactNormalizeResult {
  const trimmed = raw.trim();
  if (!trimmed) {
    // Let the form's native required validation handle empty values.
    return { ok: true, value: '' };
  }

  if (method === 'email') {
    if (!isValidEmail(trimmed)) {
      return { ok: false, errorKey: 'auth.errors.invalidEmail' };
    }
    return { ok: true, value: trimmed };
  }

  const formatted = formatUsPhone(trimmed);
  if (!isValidUsPhone(formatted)) {
    return { ok: false, errorKey: 'auth.errors.invalidPhone' };
  }
  return { ok: true, value: formatted };
}
